var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1538 13.5384C22.1538 14.1913 21.8945 14.8174 21.4329 15.279C20.9713 15.7406 20.3452 16 19.6923 16H2.46154C1.8087 16 1.1826 15.7406 0.720968 15.279C0.25934 14.8174 0 14.1913 0 13.5384V11.0769H22.1538V13.5384Z",
    fill: "#CE2028"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.9231H22.1538V11.0769H0V4.9231Z",
    fill: "#22408C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6923 0H2.46154C1.8087 0 1.1826 0.25934 0.720968 0.720968C0.25934 1.1826 0 1.8087 0 2.46154L0 4.92308H22.1538V2.46154C22.1538 1.8087 21.8945 1.1826 21.4329 0.720968C20.9713 0.25934 20.3452 0 19.6923 0V0Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRus);
export default __webpack_public_path__ + "static/media/rus.cbe628b3ba82edfbbcf62a08f5cccc7f.svg";
export { ForwardRef as ReactComponent };